import * as ToggleGroup from "@radix-ui/react-toggle-group";
import clsx from "clsx";

type ToggleGroupChipsProps = ToggleGroup.ToggleGroupSingleProps | ToggleGroup.ToggleGroupMultipleProps;

export const ToggleGroupChips = ({ children, ...props }: ToggleGroupChipsProps) => {
  return (
    <ToggleGroup.Root {...props} className="flex flex-wrap gap-2">
      {children}
    </ToggleGroup.Root>
  );
};

type ToggleGroupChipsItemProps = {
  value: string;
  label: string;
  icon?: React.ReactNode;
};

const ToggleGroupChipsItem = ({ value, label, icon }: ToggleGroupChipsItemProps) => (
  <ToggleGroup.Item
    key={value}
    value={value}
    className={clsx(
      "p-2 rounded-full",
      "bg-background-white hover:bg-background-neutral-100",
      "text-sm font-medium text-text-base-primary",
      "ring-1 ring-border-action data-[state=on]:ring-border-action-focus hover:ring-border-action-hover",
      "focus:outline-none focus:ring-border-action-hover",
      "disabled:bg-background-neutral-100 disabled:text-text-base-primary-disabled disabled:cursor-not-allowed",
      "transition-all",
      "cursor-pointer"
    )}
  >
    {icon} {label}
  </ToggleGroup.Item>
);

ToggleGroupChips.Item = ToggleGroupChipsItem;
